import gql from 'graphql-tag';

export const getCurrentPeriod = gql`
  query getCurrentPeriod {
    period {
      id
      description
      shortDescription
      startDate
      endDate
      weeks {
        id
        desc
        start
        end
      }
      modules {
        career
        code
        name
        startDate
        endDate
      }
    }
  }
`;
